<template>
  <DialogassociaRappCliente
    v-if="showDialog"
    @closeDialog="showDialog = false"
  />
  <div>
    <Loader v-if="loader" />
    <div>
      <button @click="toggleDropdown">Associa Rappresentante</button>
      <button @click="toggleForm">Crea Rappresentante</button>
    </div>

    <!-- Dropdown con campo di ricerca integrato -->
    <div v-if="showDropdown" class="dropdown mt-4 mb-4">
      <label for="representative">Seleziona Rappresentante:</label>
      <div class="custom-dropdown">
        <input
          type="text"
          v-model="searchText"
          placeholder="Cerca rappresentante..."
          class="search-input"
        />
        <ul class="dropdown-list">
          <li
            v-for="rep in filteredRappresentanti"
            :key="rep.id"
            @click="selectRepresentative(rep)"
            class="dropdown-item"
            :class="{ selected: selectedRepresentative?.id === rep.id }"
          >
            {{ rep.name }}
          </li>
        </ul>
      </div>
      <div v-if="selectedRepresentative" class="selected-representative mt-2">
        <p>Rappresentante selezionato: {{ selectedRepresentative.name }}</p>
      </div>
      <button
        v-if="selectedRepresentative"
        @click="associateRepresentative"
        class="btn-associate mt-2"
      >
        Associa
      </button>
    </div>

    <!-- Form per creare un nuovo rappresentante -->
    <div v-if="showForm" class="form full-width mt-4">
      <h3>Crea Nuovo Rappresentante</h3>

      <div class="form-grid full-width">
        <div class="form-group">
          <label for="codiceFiscale">Codice fiscale del rappresentante</label>
          <input
            id="codiceFiscale"
            v-model="newRepresentative.codiceFiscale"
            type="text"
          />
        </div>
        <div class="form-group">
          <label for="nome">Nome</label>
          <input id="nome" v-model="newRepresentative.nome" type="text" />
        </div>
        <div class="form-group">
          <label for="cognome">Cognome</label>
          <input id="cognome" v-model="newRepresentative.cognome" type="text" />
        </div>
        <div class="form-group">
          <label for="telefono">Telefono</label>
          <input
            id="telefono"
            v-model="newRepresentative.telefono"
            type="text"
          />
        </div>
        <div class="form-group">
          <label for="cellulare">Cellulare</label>
          <input
            id="cellulare"
            v-model="newRepresentative.cellulare"
            type="text"
          />
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input id="email" v-model="newRepresentative.email" type="email" />
        </div>
        <div class="form-group">
          <label for="pec">Pec</label>
          <input id="pec" v-model="newRepresentative.pec" type="text" />
        </div>
      </div>

      <h4>Indirizzo di spedizione</h4>
      <div class="form-grid full-width">
        <!-- Toponimo -->
        <div class="form-group">
          <label for="toponimo">Toponimo</label>
          <select
            id="toponimo"
            v-model="newRepresentative.toponimo"
            @click="getToponimi"
          >
            <option value="" disabled>Seleziona toponimo</option>
            <option v-for="t in toponimi" :key="t.id" :value="t.name">
              {{ t.name }}
            </option>
          </select>
        </div>
        <!-- Indirizzo -->
        <div class="form-group">
          <label for="indirizzo">Indirizzo</label>
          <input
            id="indirizzo"
            v-model="newRepresentative.indirizzo"
            type="text"
          />
        </div>
        <!-- Civico -->
        <div class="form-group">
          <label for="civico">Civico</label>
          <input id="civico" v-model="newRepresentative.civico" type="text" />
        </div>
        <!-- Cap -->
        <div class="form-group">
          <label for="cap">Cap</label>
          <input id="cap" v-model="newRepresentative.cap" type="text" />
        </div>
        <!-- Provincia -->
        <div class="form-group">
          <label for="provincia">Provincia</label>
          <select
            id="provincia"
            v-model="newRepresentative.provincia"
            @click="getDistricts"
            @change="fetchComuni"
          >
            <option value="" disabled>Seleziona provincia</option>
            <option v-for="p in province" :key="p.code" :value="p.code">
              {{ p.name }}
            </option>
          </select>
        </div>
        <!-- Comune -->
        <div class="form-group">
          <label for="comune">Comune</label>
          <select id="comune" v-model="newRepresentative.comune">
            <option value="" disabled>Seleziona comune</option>
            <option v-for="c in comuni" :key="c.id" :value="c.name">
              {{ c.name }}
            </option>
          </select>
        </div>
      </div>

      <button
        @click="createAndAssociateRepresentative"
        class="btn-associate mt-2"
      >
        Crea e Associa Rappresentante
      </button>
      <p v-if="errorMessage" class="error-message mt-2">{{ errorMessage }}</p>
    </div>

    <button class="mb-4" @click="$emit('goBack')">Torna Indietro</button>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import CreaClientiService from "@/services/ask-operation/crea-clienti-service";
import Loader from "@/components/Loader.vue";

export default {
  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },
  components: {
    Loader,
  },
  setup(props) {
    const loader = ref(false);
    const rappresentanti = ref([]);
    const selectedRepresentative = ref(null);
    const showDropdown = ref(false);
    const showForm = ref(false);
    const searchText = ref("");

    const newRepresentative = ref({
      codiceFiscale: "",
      nome: "",
      cognome: "",
      telefono: "",
      cellulare: "",
      email: "",
      pec: "",
      toponimo: "",
      indirizzo: "",
      civico: "",
      cap: "",
      provincia: "",
      comune: "",
    });
    const errorMessage = ref("");
    const toponimi = ref([]);
    const province = ref([]);
    const comuni = ref([]);

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;

    const creaClientiService = new CreaClientiService(
      self.$http,
      self.$eventBus
    );

    const fetchRappresentanti = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getRappresentanti();
        if (response && response.items) {
          rappresentanti.value = response.items.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        } else {
          console.error("Errore: Nessun dato trovato nella risposta.");
        }
      } catch (error) {
        console.error(
          "Errore durante il caricamento dei rappresentanti:",
          error
        );
      } finally {
        loader.value = false;
      }
    };

    const filteredRappresentanti = computed(() =>
      rappresentanti.value.filter((rep) =>
        rep.name.toLowerCase().includes(searchText.value.toLowerCase())
      )
    );

    const toggleDropdown = () => {
      showDropdown.value = !showDropdown.value;
      if (showDropdown.value && rappresentanti.value.length === 0) {
        fetchRappresentanti();
      }
    };

    const getToponimi = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getToponimi();
        if (response && response.items) {
          toponimi.value = response.items.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        }
      } finally {
        loader.value = false;
      }
    };

    const getDistricts = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getDistricts();
        if (response && response.items) {
          province.value = response.items.map((item) => ({
            code: item.code,
            name: item.name,
          }));
        }
      } finally {
        loader.value = false;
      }
    };

    const fetchComuni = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getCities(
          newRepresentative.value.provincia
        );
        if (response && response.items) {
          comuni.value = response.items.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        }
      } finally {
        loader.value = false;
      }
    };

    const toggleForm = () => {
      showForm.value = !showForm.value;
    };

    const selectRepresentative = (rep) => {
      selectedRepresentative.value = rep;
    };

    const associateRepresentative = async () => {
      if (!selectedRepresentative.value || !selectedRepresentative.value.id) {
        console.error(
          "Nessun rappresentante selezionato o ID rappresentante mancante."
        );
        return;
      }

      loader.value = true;

      try {
        const clientPayload = new FormData();
        clientPayload.append(
          "data",
          JSON.stringify({
            cod_fiscale: props.cliente.codfis,
            partita_iva: props.cliente.piva,
            nome: props.cliente.nome,
            cognome: props.cliente.cognome,
            rag_sociale: props.cliente.ragsoc,
            mobile: props.cliente.cellulare,
            phone: props.cliente.telefono,
            email: props.cliente.email,
            pec: props.cliente.pec,
            codice_destinatario: props.cliente.sdi,
            toponimo: props.cliente.toponimo_legale,
            address: props.cliente.indirizzo_legale,
            civico: props.cliente.civico_legale,
            cap: props.cliente.cap_legale,
            cityId: props.cliente.comune_legale,
            tipo_client: props.cliente.tipo_client,
          })
        );

        const clientResponse = await creaClientiService.saveClient(
          clientPayload
        );


        if (!clientResponse.success) {
          console.error(
            "Errore durante la creazione del cliente:",
            clientResponse.message
          );
          return;
        }

        const clientId = clientResponse.item;

        const representativePayload = {
          clientId: clientId,
          rappresentante_id: selectedRepresentative.value.id,
        };

        const associateResponse =
          await creaClientiService.associateRepresentative(
            representativePayload
          );
        

        if (associateResponse.success) {
          console.log(
            "Associazione completata con successo:",
            associateResponse.message
          );
        } else {
          console.error(
            "Errore durante l'associazione del rappresentante:",
            associateResponse.message
          );
          self.emit("closeDialog");
        }
      } catch (error) {
        console.error("Errore durante il processo di associazione:", error);
      } finally {
        loader.value = false;
        showDropdown.value = false;
      }
    };

    const createAndAssociateRepresentative = async () => {
      loader.value = true;
      errorMessage.value = "";

      try {
        const clientPayload = new FormData();
        clientPayload.append(
          "data",
          JSON.stringify({
            cod_fiscale: props.cliente.codfis,
            partita_iva: props.cliente.piva,
            nome: props.cliente.nome,
            cognome: props.cliente.cognome,
            rag_sociale: props.cliente.ragsoc,
            mobile: props.cliente.cellulare,
            phone: props.cliente.telefono,
            email: props.cliente.email,
            pec: props.cliente.pec,
            codice_destinatario: props.cliente.sdi,
            toponimo: props.cliente.toponimo_legale,
            address: props.cliente.indirizzo_legale,
            civico: props.cliente.civico_legale,
            cap: props.cliente.cap_legale,
            cityId: props.cliente.comune_legale,
            tipo_client: props.cliente.tipo_client,
          })
        );

        const clientResponse = await creaClientiService.saveClient(
          clientPayload
        );


        if (!clientResponse.success) {
          errorMessage.value = "Errore durante la creazione del cliente";
          return;
        }

        const clientId = clientResponse.item;

        const representativePayload = new FormData();
        representativePayload.append(
          "data",
          JSON.stringify({
            codfis: newRepresentative.value.codiceFiscale,
            name: `${newRepresentative.value.nome} ${newRepresentative.value.cognome}`.trim(),
            telefono: newRepresentative.value.telefono,
            cellulare: newRepresentative.value.cellulare,
            email: newRepresentative.value.email,
            pec: newRepresentative.value.pec,
            toponimo: newRepresentative.value.toponimo,
            indirizzo: newRepresentative.value.indirizzo,
            civico: newRepresentative.value.civico,
            cap: newRepresentative.value.cap,
            provincia: newRepresentative.value.provincia,
            comune: newRepresentative.value.comune,
          })
        );

        try {
          const representativeResponse =
            await creaClientiService.saveRepresentative(representativePayload);

          if (!representativeResponse.success) {
            errorMessage.value =
              representativeResponse.message ||
              "Errore durante la creazione del rappresentante";
            return;
          }

          const rappresentante_id = representativeResponse.item;

          if (!rappresentante_id) {
            errorMessage.value = "Errore: rappresentante_id è null o undefined";
            return;
          }

          const associationPayload = {
            clientId: clientId,
            rappresentante_id: rappresentante_id,
          };


          const associationResponse =
            await creaClientiService.associateRepresentative(
              associationPayload
            );
          

          if (!associationResponse.success) {
            errorMessage.value =
              associationResponse.message ||
              "Errore durante l'associazione del rappresentante";
          } else {
            errorMessage.value = "";
            self.emit("closeDialog");
          }
        } catch (error) {
          if (error.response && error.response.status === 409) {
            errorMessage.value =
              error.response.data.message ||
              "Conflitto rilevato durante la creazione del rappresentante.";
          } else {
            errorMessage.value =
              "Errore generico durante la creazione del rappresentante";
          }
        }
      } catch (error) {
        errorMessage.value =
          "Errore durante il processo di creazione e associazione";
      } finally {
        loader.value = false;
      }
    };

      
    const addNotification = (type, message) => {
      const notificationElement = document.createElement("div");
      notificationElement.className = `notification ${type}`;
      notificationElement.innerText = message;
      document.body.appendChild(notificationElement);

      setTimeout(() => {
        notificationElement.remove();
      }, 5000);
    };

    onMounted(() => {
      fetchRappresentanti();
      getToponimi();
      getDistricts();
    });

    return {
      loader,
      rappresentanti,
      selectedRepresentative,
      showDropdown,
      showForm,
      searchText,
      newRepresentative,
      toponimi,
      province,
      comuni,
      getToponimi,
      getDistricts,
      fetchComuni,
      toggleForm,
      filteredRappresentanti,
      toggleDropdown,
      selectRepresentative,
      associateRepresentative,
      createAndAssociateRepresentative,
      addNotification,
      showDialog: false,
      errorMessage,
    };
  },
};
</script>

<style scoped>
p {
  font-size: 18px;
  color: #4caf50;
}
button {
  padding: 1.3em 3em;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 2.5px;
  font-weight: 500;
  color: #000;
  background-color: #fff;
  border: none;
  border-radius: 45px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  margin-right: 10px;
  margin-top: 10px;
}

button:hover {
  background-color: #357bb8c4;
  box-shadow: 0px 15px 20px #357ab8;
  color: #fff;
  transform: translateY(-5px);
}

button:active {
  transform: translateY(-5px);
}

.custom-dropdown {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
}

.search-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.dropdown-item {
  padding: 8px 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: bold;
  margin-bottom: 4px;
}

input,
select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

dropdown-item.selected {
  background-color: #e0f7fa;
  font-weight: bold;
}

.btn-associate {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-associate:hover {
  background-color: #218838;
}

.btn-associate:active {
  transform: translateY(1px);
}

.error-message {
  color: #dc3545;
  font-size: 14px;
  margin-top: 8px;
}



</style>

